<script lang="ts" setup>
import type { CheckCallDTO } from "@/api/trips/dto/check-call";
import { useAppStore } from "@/store/app.store";
import { useDateTime } from "@/composables";

const { timeAgo, dateTZ } = useDateTime();

const appStore = useAppStore();

defineProps<{
  checkCall: CheckCallDTO;
}>();
</script>

<template>
  <div class="text-grey-darken-3 font-weight-500" data-qa="cc-tab-date-1">
    {{ dateTZ(checkCall.checkCallTime, appStore.dispatcher!.timezone) }}
  </div>
  <div class="text-grey-darken-1" data-qa="cc-tab-date-2">
    {{ dateTZ(checkCall.checkCallTime, checkCall.timezone) }}
  </div>
  <div class="text-grey-darken-1 font-size-12 font-weight-500" data-qa="time-from-event">
    {{ timeAgo(checkCall.checkCallTime) }}
  </div>
</template>
